import { render, staticRenderFns } from "./OAuthSuccess.vue?vue&type=template&id=31d784e0&"
import script from "./OAuthSuccess.vue?vue&type=script&lang=js&"
export * from "./OAuthSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports